import { TargetProperty } from "@../constants";
import { api } from "@shared/api/client";

export const updateTargetProperty = (
  applicationId: number,
  params: TargetProperty
  // We receive `{}` from API response
  // eslint-disable-next-line @typescript-eslint/ban-types
) => api.put<{}>(`/applications/${applicationId}/property`, params);
